import ApiService from "@/common/api/api.service";

const DashboardProponenteService = {
    valorInvestido: function (empresaId, grupoNegocio) {
        const empresasIds = mappingEmpresasIds(empresaId)
        return ApiService.get(`/dashboardProponente/valor-investido?${empresasIds}&grupoNegocio=${grupoNegocio}`);
    },

    valorComprometido: function (empresaId, grupoNegocio) {
        const empresasIds = mappingEmpresasIds(empresaId)
        return ApiService.get(`/dashboardProponente/valor-comprometido?${empresasIds}&grupoNegocio=${grupoNegocio}`);
    },

    saldoCustosProprios: function (empresaId, grupoNegocio) {
        const empresasIds = mappingEmpresasIds(empresaId)
        return ApiService.get(`/dashboardProponente/saldo-custos-proprios?${empresasIds}&grupoNegocio=${grupoNegocio}`);
    },

    projetosAndamento: function (empresaId, grupoNegocio) {
        const empresasIds = mappingEmpresasIds(empresaId)
        return ApiService.get(`/dashboardProponente/projetos-andamento?${empresasIds}&grupoNegocio=${grupoNegocio}`);
    },

    valorInvestidoNonece: function (empresaId, grupoNegocio) {
        const empresasIds = mappingEmpresasIds(empresaId)
        return ApiService.get(`/dashboardProponente/valor-investido-nonece?${empresasIds}&grupoNegocio=${grupoNegocio}`);
    },

    projetos: function (empresaId, grupoNegocio, filtro) {
        const empresasIds = mappingEmpresasIds(empresaId)
        return ApiService.get(`/dashboardProponente/projetos?${empresasIds}&grupoNegocio=${grupoNegocio}${filtro.codigoProjeto ? `&CodigoProjeto=${filtro.codigoProjeto}` : ''}${filtro.faseInovacao ? `&FaseInovacao=${filtro.faseInovacao}` : ''}${filtro.status ? `&Status=${filtro.status}` : ''}${filtro.dataInicio ? `&DataInicio=${filtro.dataInicio}` : ''}${filtro.dataFim ? `&DataFim=${filtro.dataFim}` : ''}`);
    },

    graficoMovimentacaoFinanceira: function (empresaId, grupoNegocio, filtro) {
        const empresasIds = mappingEmpresasIds(empresaId)
        return ApiService.get(`/dashboardProponente/grafico-movimentacao-financeira?${empresasIds}&grupoNegocio=${grupoNegocio}${filtro.ano ? `&Ano=${filtro.ano}` : ''}${filtro.anoFim ? `&AnoFim=${filtro.anoFim}` : ''}${filtro.mesInicio ? `&MesInicio=${filtro.mesInicio}` : ''}${filtro.mesFim ? `&MesFim=${filtro.mesFim}` : ''}`);
    }
};


function mappingEmpresasIds(empresasIds) {
    if (empresasIds?.length > 0) {
        const params = empresasIds?.map((value, index, empresasIds) => {
            if (index + 1 === empresasIds.length) {
                return `empresaId=${value}`
            } else {
                return `empresaId=${value}&`
            }
        })
        return params.join('')
    }
    else {
        return empresasIds
    }
}
export default DashboardProponenteService;